import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';

import { InputErrorModule } from '../input-error/input-error.module';
import { LoginRoutes } from './login.routes';
import { LoginScreenComponent } from './login-screen/login-screen.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    InputErrorModule,
    LoginRoutes
  ],
  declarations: [
    LoginScreenComponent,
    ChangePasswordComponent
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/login/login.module.ts